import { useQuery } from '@tanstack/react-query';
import {
  RouteResource,
  ShiftResource,
  TurnResource,
  turnsGetOtherTeamLeaders,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

type TurnWithTurnLeader = {
  turn: Omit<TurnResource, 'id' | 'shift' | 'route'> & {
    id: number;
    shift: ShiftResource;
    route: RouteResource;
  };
  turnLeader: {
    id: number;
    firstName: string;
    lastName: string;
    phone: string;
  };
};

export const useOtherTeamLeaders = (args: { id: number }) =>
  useQuery({
    queryFn: async () => {
      const result = await extractData(
        turnsGetOtherTeamLeaders({
          path: { id: args.id },
          query: { expand: ['turn.shift', 'turn.route'] },
        })
      );
      return result as unknown as TurnWithTurnLeader[];
    },
    select(data) {
      data.sort((a, b) =>
        a.turn?.shift.startDate.localeCompare(b.turn?.shift.startDate)
      );
      return Object.groupBy(data, (item) => item.turn.shift.id!);
    },
    queryKey: ['turns', args.id, 'otherTeamLeaders'],
  });
